import {isNullOrUndefined} from "util";
import * as xml2js from "xml2js";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {map, mergeMap} from "rxjs/operators";

function parseNumbers(str) {
  if (str !== '') {
    str = xml2js.processors.parseNumbers(str);
  }
  return str;
}


export class XmlUtils {

  private static _toJSON(xml: string, numbers: boolean = false, booleans: boolean = false): Observable<any> {
    return new Observable((observer) => {

      const processors = [].concat(numbers ? [parseNumbers] : []).concat(booleans ? [xml2js.processors.parseBooleans] : []);
      // const parseString = xml2js.parseString;
      const parser = new xml2js.Parser({
        mergeAttrs: true,
        explicitArray: false,
        valueProcessors: processors,          // To check if parse invalid value
        attrValueProcessors: processors       // To check if parse invalid value
      });

      parser.parseString(xml, (err, result) => {
        if (!isNullOrUndefined(result)) {
          observer.next(result);
          observer.complete();
        } else {
          try {
            // try to convert JSON
            observer.next(JSON.parse(xml));
            observer.complete();
          } catch (e) {
            observer.error('Invalid XML or JSON ' + e);
          }
        }

      });
    });
  }

  // This function was added because the new implementation return a string of string that contain the content
  // if this happens this function will clean the string.
  public static strStrToStrObj(d:  Observable<string>): Observable<string> {
    return d.pipe(
      map(x => x.startsWith("\"") && x.endsWith("\"") ? x.replace(/\\"/ig, '"').slice(1, -1) : x),
    );
  }

  // This operator convert a string in json the string could be a json or a xml
  public static toJSON(d: Observable<string>): Observable<any> {
    return d.pipe(
      XmlUtils.strStrToStrObj,
      mergeMap(txt => XmlUtils._toJSON(txt))
    );
  }
  public static loadXmlFile(http: HttpClient, fileName: string): Observable<any> {
    if (!fileName || fileName === '') {
      return of({}); // EMPTY object
    } else {
//      const ext = fileName.endsWith(".xml") ? '' : '.xml';
      return http.get(fileName, {responseType: 'text', withCredentials: true}).pipe(
        // tap((x) => console.log('LoadXmlFile form url', fileName, x)),
        XmlUtils.toJSON
      );

    }
  }
}
